import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import exam from './modules/exam'

import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { user, exam },
  getters
})

export default store
